// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3bHq0","content":"styles_content___01jN","checkbox":"styles_checkbox__1E3bk","checkboxLabel":"styles_checkboxLabel__2kp25"};